// extracted by mini-css-extract-plugin
export default {"cardContainer":"MovieCard_cardContainer__5f6Hs","btn":"MovieCard_btn__nAny5","icon":"MovieCard_icon__mxmlR","movieYearLength":"MovieCard_movieYearLength__7VmSk"};